<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div id="container" class="apply_st">
        <div v-on-clickaway="close" class="inner">
          <button class="close_btn" @click="close"></button>
          <div class="box_wrap">
            <div class="box tac">
              <div ref="focus" class="box_title">
                <h2>도서신청</h2>
                <p class="guide_txt">* 표시 항목은 필수 입력 해주세요.</p>
              </div>
              <div class="apply_formlist">
                <ul class="form_wrap">
                  <li>
                    <p class="subtitle">쿠폰 번호*</p>
                    <input
                      v-model="couponNo"
                      type="text"
                      placeholder=""
                      class="input_t"
                    />
                  </li>
                  <li>
                    <p class="subtitle">강의 학기*</p>
                    <input
                      id="authorName"
                      v-model="classSem"
                      type="text"
                      placeholder=""
                      class="input_t"
                    />
                  </li>
                  <li>
                    <p class="subtitle">강의 학교</p>
                    <input
                      v-model="classSchool"
                      type="text"
                      placeholder="강의학교를 선택해주세요"
                      class="input_t"
                      readonly
                    />
                  </li>
                  <li>
                    <p class="subtitle">
                      강의 학부<span class="sm-txt">(학과)</span>*
                    </p>
                    <input
                      v-model="classDivision"
                      type="text"
                      placeholder=""
                      class="input_t"
                    />
                  </li>
                  <li>
                    <p class="subtitle">강의 명*</p>
                    <input
                      v-model="className"
                      type="text"
                      placeholder=""
                      class="input_t"
                    />
                  </li>
                  <li>
                    <p class="subtitle">수강 학생 수</p>
                    <input
                      v-model="classStudents"
                      type="text"
                      placeholder=""
                      class="input_t"
                    />
                  </li>
                  <li>
                    <p class="subtitle t_20">이전 사용 교재명/<br />출판사명</p>
                    <div class="input_t_wrap">
                      <input
                        v-model="beforeClassName"
                        type="text"
                        placeholder="이전 교재명을 입력해주세요."
                        class="input_t"
                      />
                      <input
                        v-model="beforePublish"
                        type="text"
                        placeholder="이전 출판사명을 입력해주세요"
                        class="input_t"
                      />
                    </div>
                  </li>
                  <li>
                    <label for="publishingYear">
                      <p class="subtitle">강의 명*</p>
                      <input
                        v-model="className"
                        type="text"
                        placeholder=""
                        class="input_t"
                      />
                    </label>
                  </li>
                </ul>
              </div>
              <div class="btn_wrap">
                <button class="box_btn" @click="requestPresent">
                  <span class="an_t">받기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <!-- ERROR MODAL START -->
        <transition name="modal-fade">
          <Modal v-if="showErrorModal">
            <div v-on-clickaway="toggleErrorModal" class="ly_pop_wrap">
              <div class="ly_pop_content ly_pop_msg ly_txt ly_alert">
                <div class="ly_inner">
                  <strong>
                    {{ modalMsg }}
                  </strong>
                  <p>
                    {{ modalSubMsg }}
                  </p>
                  <div class="btnWrap">
                    <button class="box_btn" @click="closeModal">
                      <span class="an_t">확인</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </transition>
        <!-- ERROR MODAL END -->
      </div>
    </Modal>
  </transition>
</template>

<script>
export default {
  name: 'PresentModal',
  data() {
    return {
      searchTxt: '',
      isShowModal: false,
      showErrorModal: false,
      currentPage: 1,
      applyPerPage: 10,
      set: '',
      inOnModal: false,
      className: '',
      classSem: '',
      classSchool: '',
      class: '',
      bookData: '',
      modalMsg: '',
      modalSubMsg: '',
      modalTitleTxt: ''
    }
  },
  mounted() {},
  methods: {
    requestPresent() {},
    closeModal() {
      this.isShowModal = false
      this.showErrorModal = false
    },
    searchBook(set) {
      this.$store.dispatch('bookSearchTxt', set).then((res) => {
        return new Promise((resolve) => {
          resolve(res, true)
        })
      })
    },
    toggleErrorModal() {
      this.modalTitleTxt = '알림창'
      this.showErrorModal = !this.showErrorModal
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
// 학지추가

.input_t_wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0px 12px;
}
.t_20 {
  top: 20% !important;
}
// 학지추가
.section .inner {
  padding: 132px 0 124px;
}
.apply_st .box_wrap {
  padding-bottom: 89px;
}
.apply_st .box_wrap,
.apply_st .box_wrap .box {
  width: 100%;
  max-width: 920px;
}
.apply_formlist {
  text-align: left;
  margin-bottom: 60px;
}
.apply_formlist .form_wrap li {
  padding-left: 148px;
  position: relative;
}
.apply_formlist .form_wrap li:first-child input {
  // width: calc(100% - 120px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.apply_formlist .form_wrap li input {
  width: 100%;
}
.apply_formlist .form_wrap li p {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: -0.03em;
  height: 22px;
}
.btn_wrap .box_btn {
  width: 259px;
}
.btn_wrap .box_btn:first-child {
  margin-right: 14px;
}
.book_search {
  width: 112px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  background: #67788a;
  color: #fff;
  font-size: 16px;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  position: absolute;
  right: 0;
  top: 0;
}
.ly_alert {
  width: 540px;
  padding: 65px 58px 60px;
}
.ly_alert .ly_inner {
  padding: 0 !important;
  text-align: center;
  background-color: #f0f5fa !important;
}
.ly_alert .ly_inner strong {
  padding-top: 83px;
  padding-bottom: 8px;
  display: block;
  //   background: url(../../assets/images/pop_msg/msg_pod2.png) no-repeat top center;
}
.ly_alert .ly_inner p {
  color: #627283;
  font-size: 16px;
  margin-top: 0;
  letter-spacing: -0.03em;
  word-break: keep-all;
}
.ly_alert .ly_inner .btnWrap {
  margin-top: 24px;
}
@media (max-width: 1024px) {
  .box_wrap {
    padding: 48px 0px !important;
    border-radius: 20px;
  }
  //   .apply_st .box_wrap,
  //   .apply_st .box_wrap .box {
  //     width: 100%;
  //   }
  //   #container {
  //     min-height: auto !important;
  //   }
  //   .section .inner {
  //     padding: 20px 0;
  //   }
  //   .apply_st .box_wrap {
  //     padding: 50px 0;
  //     border-radius: 0;
  //   }
}
@media (max-width: 767px) {
  //   .btn_wrap .box_btn {
  //     width: auto;
  //   }
  //   .apply_formlist .form_wrap li {
  //     padding-left: 68px;
  //   }
  //   .apply_formlist .form_wrap li:first-child input {
  //     width: calc(100% - 80px);
  //   }
  //   .book_search {
  //     width: 70px;
  //   }
}
</style>
